var map = {
	"./pirateLogin1.webp": 56603,
	"./pirateLogin10.webp": 84157,
	"./pirateLogin11.webp": 97746,
	"./pirateLogin2.webp": 69754,
	"./pirateLogin3.webp": 41253,
	"./pirateLogin4.webp": 29460,
	"./pirateLogin5.webp": 52471,
	"./pirateLogin6.webp": 15094,
	"./pirateLogin7.webp": 88721,
	"./pirateLogin8.webp": 52688,
	"./pirateLogin9.webp": 78451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73929;